import { mockData as documentEventsData } from '@web/lib/demo/data/documentEvents';
import { filterData } from '@web/lib/demo/utils';
export var userLastActivity = function (input) {
    var lastActivity = filterData(documentEventsData, [
        {
            key: 'userId',
            value: String(input.userId),
            operator: 'eq'
        }
    ]).sort(function (a, b) { return new Date(b.date).getTime() - new Date(a.date).getTime(); })[0];
    return (lastActivity === null || lastActivity === void 0 ? void 0 : lastActivity.date) || new Date().toISOString();
};
